/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { mobileOrderItemModifierSchema } from "./mobileOrderItemModifierSchema.ts";

export const mobileOrderItemGroupModifierSchema = z.object({
	group: z.uuid(),
	name: z.string(),
	image_link: z.string().nullable(),
	modifiers: z.array(mobileOrderItemModifierSchema),
});
